/**
 * Created by 丸子 on 2018/7/19 0019.
 */
import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    accountInfo:'',// 登录
    USDTBalance:'',// 余额
    WBNBBalance:'',// 余额
    isUser:false, //是否存在
  },
  modules: {},
  mutations: {
    isUser (state, data) {
      this.state.isUser = data;
    },
    setAccountInfo (state, data) {
      this.state.accountInfo = data;
    },
    // 获取USDT余额
    USDTBalance (state, data) {
      this.state.USDTBalance = data;
    },
    WBNBBalance (state, data) {
      this.state.WBNBBalance = data;
    },
  },
})
